import { apiClient } from '../utils/api';

export interface ApiReview {
  reviewId: string;
  rating: number;
  timestamp: string;
  userName: string;
  orderId: string;
  images: string[];
  reviewText: string;
  vendorReply: string;
  vendorReplyTimestamp: string;
}

export interface ReviewsApiResponse {
  success: boolean;
  data: ApiReview[];
  count: number;
  averageRating: string;
  message:string
}

export interface ReplyPayload {
  vendorId: string;
  reviewId: string;
  reply: string;
}

// Get all reviews for a vendor (optionally filtered by reviewId)
export const getReviews = async (vendorId: string, reviewId?: string): Promise<ReviewsApiResponse> => {
  const url = reviewId 
    ? `/vendors/${vendorId}/reviews?reviewId=${encodeURIComponent(reviewId)}`
    : `/vendors/${vendorId}/reviews`;
  const response = await apiClient.get<ReviewsApiResponse>(url);
  return response.data;
};

// Submit a reply to a review
export const submitReply = async (payload: ReplyPayload): Promise<any> => {
  const response = await apiClient.post(
    `/vendors/${payload.vendorId}/reviews/${payload.reviewId}/reply`,
    { reply: payload.reply }
  );
  return response.data;
};

// Update a reply
export const updateReply = async (payload: ReplyPayload): Promise<any> => {
  const response = await apiClient.put(
    `/vendors/${payload.vendorId}/reviews/${payload.reviewId}/reply`,
    { reply: payload.reply }
  );
  return response.data;
};





